/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	MissingStudentEnrollmentReportDTO,
	MissingStudentEnrollmentReportDTOFromJSON,
	MissingStudentEnrollmentReportDTOFromJSONTyped,
	MissingStudentEnrollmentReportDTOToJSON,
} from "./MissingStudentEnrollmentReportDTO";

/**
 *
 * @export
 * @interface MissingStudentEnrollmentReportDTOPagedResponse
 */
export interface MissingStudentEnrollmentReportDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof MissingStudentEnrollmentReportDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof MissingStudentEnrollmentReportDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof MissingStudentEnrollmentReportDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<MissingStudentEnrollmentReportDTO>}
	 * @memberof MissingStudentEnrollmentReportDTOPagedResponse
	 */
	data?: Array<MissingStudentEnrollmentReportDTO> | null;
}

export function MissingStudentEnrollmentReportDTOPagedResponseFromJSON(
	json: any
): MissingStudentEnrollmentReportDTOPagedResponse {
	return MissingStudentEnrollmentReportDTOPagedResponseFromJSONTyped(
		json,
		false
	);
}

export function MissingStudentEnrollmentReportDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): MissingStudentEnrollmentReportDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(
					MissingStudentEnrollmentReportDTOFromJSON
			  ),
	};
}

export function MissingStudentEnrollmentReportDTOPagedResponseToJSON(
	value?: MissingStudentEnrollmentReportDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(
						MissingStudentEnrollmentReportDTOToJSON
				  ),
	};
}
